export { default, default as AudioPlayer } from "./index.svelte"
